export default "__VITE_ASSET__D6N6aJcN__"